import React, { Component } from "react";
import "../LandingPage/LandingPageStyleSheet.css";
import ConversationListCell from "../LandingPage/ConversationListCell";
import NewConversationTab from "../LandingPage/NewConversation";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import HWLog from "../HWLibrary/HWLog";
import CircularProgress from "@material-ui/core/CircularProgress";

class ConversationList extends Component {
  constructor(props) {
    super(props);
    this.conversationListRef = React.createRef();
  }

  render() {
    let conversations = this.props.conversations || [];

    let activeConv = conversations.filter(
      (conversation) => conversation.active
    );
    let prevConv = conversations.filter((conversation) => !conversation.active);
    let isFetchingConversations = this.props.isFetchingConversations || false;

    return (
      <div
        className={"s360-conversation-list-container"}
        style={this.containerStyle()}
      >
        <div
          className="s360-conversation-list-all-conversation"
          style={this.allConversationStyle()}
        >
          All Conversations
        </div>
        <div
          ref={this.conversationListRef}
          onScroll={this.onConversationListScroll}
          className="s360-conversation-list-conversation-cell"
        >
          {isFetchingConversations && (
            <div
              className="s360-conversation-history-list-cell-activity-indicator"
              style={{
                color:
                  this.props.config.designDetails.headerColor || "lightgray",
              }}
            >
              <CircularProgress color="inherit" size={20} />
            </div>
          )}

          {activeConv.length > 0 ? (
            <div
              style={{
                fontSize: "12px",
                color: "#AAAAAA",
                marginLeft: "12px",
                color: "black",
                marginTop: "5px",
                marginBottom: "5px",
                fontFamily: "poppins",
              }}
            >
              Active Conversation
            </div>
          ) : (
            ""
          )}
          {activeConv.map((conversation, index) => (
            <ConversationListCell
              key={conversation.sessionId + "session-id-cell"}
              {...this.props}
              conversation={conversation}
            />
          ))}

          {prevConv.length > 0 ? (
            <div
              style={{
                fontSize: "12px",
                color: "#AAAAAA",
                marginLeft: "12px",
                color: "black",
                marginTop: "5px",
                marginBottom: "5px",
                fontFamily: "poppins",
              }}
            >
              Previous Conversation
            </div>
          ) : (
            ""
          )}
          {prevConv.map((conversation, index) => (
            <ConversationListCell
              key={conversation.sessionId + "session-id-cell"}
              {...this.props}
              conversation={conversation}
            />
          ))}

          {!isFetchingConversations &&
          activeConv.length == 0 &&
          prevConv.length == 0 ? (
            <div
              style={{
                fontSize: "15px",
                color: "#AAAAAA",
                marginLeft: "12px",
                textAlign: "center",
                marginTop: "110px",
                fontFamily: "poppins",
              }}
            >
              {this.props.config.configDetails.noconversation}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="s360-conversation-list-new-conversation-tab-container">
          {(this.props.config.configDetails.startNewSession ||
            (this.props.areAllPreviousSessionsClosed ? true : false)) && (
            <NewConversationTab {...this.props} />
          )}
        </div>
        {/* <div className="s360-conversation-list-default-footer"> */}
        <DefaultFooter {...this.props} />
        {/* </div> */}
      </div>
    );
  }

  containerStyle = () => {
    let config = this.props.config;
    return {
      backgroundColor: config.designDetails.pageBackgroundColor,
    };
  };

  allConversationStyle = () => {
    return {
      fontFamily: this.props.config.designDetails.convHeaderFont,
      fontSize: this.props.config.designDetails.convHeaderFontSize + "px",
      color: this.props.config.designDetails.convHeaderMessageFontColor,
    };
  };

  onConversationListScroll = () => {
    let scrollContainer = this.conversationListRef.current;
    let isBottom =
      scrollContainer.scrollHeight - scrollContainer.scrollTop ===
      scrollContainer.clientHeight;
    if (isBottom) {
      this.props.onScrollToBottom();
    }
  };
}
export default ConversationList;
